import React, { useState } from 'react';
import { domSanitizer } from '../../../../services/helperFunctions';
import { Carousel } from 'react-responsive-carousel';
import Modal from '@material-ui/core/Modal';
import LinearProgress from '@material-ui/core/LinearProgress';
import { FundEmergency, PrimaryButton, SelectionWarningBox } from '../index';
import { handleRupee } from '../../../../services/helperFunctions';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Close from '../../../public/images/icon-close-white.png';
import KettoVerified from '../../../public/images/ketto-verified.png';

export const FundraiserDetials = ({
  data,
  handleAllocateFunds,
  showLimitError,
  limit,
  handleCloseSelectionError,
}) => {
  const description = data && data.about ? data.about.info_1 : '';
  const gallery = data && data.gallery ? data.gallery : [];
  const bills = data && data.viewmedicalbill ? data.viewmedicalbill : [];
  const isUrgent = !!(data && data.display_type_self && data.display_type_self === 'urgent');
  const goalAmount = data && data.amount_requested ? data.amount_requested : '';
  const raisedAmount = data && data.raised ? data.raised.raised : '';
  const supporters = data && data.raised ? data.raised.backers : '';
  const percentage = ((raisedAmount / goalAmount) * 100);
  const [selectedImage, setImage] = useState(false);

  const handleOpenPopup = (img) => setImage(img);
  const handleClosePopup = () => setImage(false);

  return (
    <div className="details-container">
      {isUrgent && <FundEmergency />}
      <div className="title-row">
        <p className="fs-18 lh-28 text-bold mb-0">
          {data.title}
        </p>
      </div>
      <div className="gallery-area bg-grey position-relative">
        <img src={KettoVerified} alt="Ketto Verified" className="ketto-verified" />
        {gallery && gallery.length > 0
          && (
            <Carousel showThumbs={false} showStatus={false} autoPlay={false}>
              {gallery.map((imageData) => (
                <div key={imageData.id}>
                  <img src={imageData.cdn_path} alt="fundraiser img" />
                </div>
              ))}
            </Carousel>
          )}
      </div>
      <div className="fund-details">
        <div className="d-flex">
          <h3>
            ₹&nbsp;
            {handleRupee(raisedAmount)}
          </h3>
          <span className="fs-12 text-grey" style={{ marginTop: '7px' }}>&nbsp;raised</span>
        </div>
        <p className="fs-12 mb-0">
          Goal of
          {' '}
          <span className="text-bold">
            ₹&nbsp;
            {handleRupee(goalAmount)}
          </span>
        </p>
        <LinearProgress className="progress-bar" variant="determinate" value={percentage} />
        <p className="fs-14 lh-20 text-grey mb-0">
          <span style={{ color: '#444444' }}>{supporters}</span>
          {' '}
          Supporters
        </p>
      </div>
      <div className={`about-area ${!bills || bills.length == 0 ? 'margin' : ''}`}>
        <p className="fs-18 lh-23 text-bold">About the Fundraiser</p>
        <div dangerouslySetInnerHTML={{ __html: domSanitizer(description) }}>

        </div>
      </div>
      {bills && bills.length > 0 && <p className="fs-18 lh-23 text-bold mb-2 text-left" style={{ padding: '0 20px' }}>Documents</p>}
      {bills && bills.length > 0
        && (
          <div className="documents-area">
            <Carousel showThumbs={false} showStatus={false} autoPlay={false}>
              {bills.map((imageData) => (
                <div key={imageData.id} onClick={() => handleOpenPopup(imageData.cdn_path)}>
                  <img src={imageData.cdn_path} alt="fundraiser img" />
                </div>
              ))}
            </Carousel>
          </div>
        )}
      {showLimitError && <SelectionWarningBox limit={limit} handleCloseSelectionError={handleCloseSelectionError} />}
      <div className="internal-selection-btn ">
        <PrimaryButton
            text="SELECT FUNDRAISER"
            type="large"
            textBold="true"
            action={() => handleAllocateFunds(data.id)}
            fsize="16" />
      </div>
      <Modal open={!!selectedImage} onClose={handleClosePopup}>
        <div className="selected-image-popup">
          <div className="d-flex w-100 justify-content-end">
            <div className="modal-close-bg">
              <img src={Close} alt="Close icon" onClick={handleClosePopup} />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
            <img src={selectedImage} alt="Selected document" />
            {/* <Carousel showThumbs={false} showStatus={false} autoPlay={false}>
              {bills.map((imageData) => (
                <div key={imageData.id} onClick={() => handleOpenPopup(imageData.cdn_path)}>
                  <img src={imageData.cdn_path} alt="fundraiser img" />
                </div>
              ))}
            </Carousel> */}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FundraiserDetials;
